import { IModelEntity } from '@pit/core';
import { ShipmentProcessState } from './dto.shipment.process.interface';

export interface IDtoStatsDepotShipments extends IModelEntity {

    depot?: string;
    processState?: ShipmentProcessState;
    amount?: number;

}
